// AdminLogin.js - Admin login page component
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/AdminLogin.css";

function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const login = async () => {
    if (!email || !password) { alert("Fill in all fields"); return; }
    setLoading(true);

    const API_URL = process.env.REACT_APP_API_URL;

    if (!API_URL) {
      alert("API URL is not configured. Check REACT_APP_API_URL environment variable.");
      setLoading(false);
      return;
    }

    try {
      const res = await fetch(`${API_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password })
      });

      const data = await res.json();

      if (!res.ok) {
        alert(data.message || `Server error: ${res.status}`);
        return;
      }

      if (!data.token) {
        alert(data.message || "Invalid login — no token returned");
        return;
      }

      localStorage.setItem("token", data.token);
      navigate("/admin/dashboard");
    } catch (err) {
      alert(`Login error: ${err.message}. Check console for details.`);
      console.error("Login fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-auth-page">
      <div className="admin-card">
        <h2>Admin Login</h2>
        <input
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          value={email}
        />
        <input
          type="password"
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          value={password}
        />
        <button onClick={login} disabled={loading}>
          {loading ? "Logging in..." : "Login"}
        </button>
      </div>
    </div>
  );
}

export default AdminLogin;